import type { GlobalCalWithoutNs } from '@calcom/embed-core';
import loadCalEmbed from '@calcom/embed-snippet';

/**
 * Cal.com namespaced embed API (popup modal). Matches the flow from @calcom/embed-react getCalApi,
 * implemented via @calcom/embed-snippet so Create React App / webpack 4 can bundle it.
 *
 * @see https://developer.cal.com/embed/install-with-react
 */
export function getCalApiForNamespace(options: {
  namespace: string;
  embedJsUrl?: string;
}): Promise<GlobalCalWithoutNs> {
  const { namespace, embedJsUrl } = options;
  if (!namespace) {
    return Promise.reject(new Error('Cal embed namespace is required'));
  }

  return new Promise((resolve) => {
    const Cal = loadCalEmbed(embedJsUrl);
    Cal('init', namespace);

    const poll = () => {
      const api = Cal.ns[namespace];
      if (api) {
        resolve(api);
        return;
      }
      setTimeout(poll, 50);
    };

    poll();
  });
}
